export default "__VITE_PUBLIC_ASSET__c0c23847__"